<div class="overflow-x-hidden p-[3%] " >
  <div class="grid grid-cols-2 h-full w-full">
    <div style="color: var(--main, #0C1838);
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;">Edit Site Details</div>
    <div class="grid justify-end">
      <mat-icon [svgIcon]="'custom:close'" class="pointer " (click)="onCloseBtnClick()"></mat-icon>
    </div>
  </div>
  <hr class="relative top-[2vh] w-full">
  <div class="heading relative pt-[3vh] w-full">
    Day Timings
  </div>
  <div class="grid grid-cols-2 relative pt-[2vh] w-full">
    <div class="sub-heading">
      From
    </div>
    <div class="sub-heading">
      To
    </div>
  </div>
  <div class="grid grid-cols-2 relative pt-[2vh] w-full">
    <button class="btn-style  h-full w-[95%]">
      <input matInput [type]="'time'" placeholder="Select Time"  [(ngModel)]="day_start_time" (change)="onDayStartTimeSelected($event.target.value)" required autocomplete="on">
    </button>   
    <button  class="btn-style  h-full w-[95%]">
      <input matInput [type]="'time'" placeholder="Select Time"  [(ngModel)]="day_end_time" (change)="onDayEndTimeSelected($event.target.value)" required autocomplete="on">
    </button> 
  </div>

  
  <div class="heading relative pt-[2vh] w-full">
    Night Timings
  </div>
  <div class="grid grid-cols-2 relative pt-[2vh] w-full">
    <div class="sub-heading">
      From
    </div>
    <div class="sub-heading">
      To
    </div>
  </div>
  <div class="grid grid-cols-2 relative pt-[2vh] w-full">
    <button class="btn-style w-[95%]">
      <input matInput [type]="'time'" placeholder="Select Time"  [(ngModel)]="night_start_time" (change)="onNightStartTimeSelected($event.target.value)" required autocomplete="on">
    </button>   
    <button  class="btn-style  w-[95%]">
      <input matInput [type]="'time'" placeholder="Select Time"  [(ngModel)]="night_end_time" (change)="onNightEndTimeSelected($event.target.value)" required autocomplete="on">
    </button> 
  </div>

  <div class="heading relative pt-[2vh] w-full">
    Speed Limit
  </div>
  <div class=" relative pt-[2vh] w-full">
    {{speed_limit ? speed_limit : '-'}}&nbsp;&nbsp;km/hr
  </div>

  <hr class="heading relative">
  <div class="grid justify-end pt-[2vh]">
    <button id="saveEditDetails" class="moveBtn hover:shadow-lg pt-[3vh] relative w-full h-full"   (click)="saveSiteDetails()" [disabled]="saveBtnEnable">
      <p class="btnText text-lg font-bold relative pointer" >
        Save Details 
    </p>
    </button>
  </div>

</div>
